import React, { createContext, useContext, useMemo } from "react";
import PropTypes from "prop-types";
//Limitless imports
import { useDevLogging } from "common/hooks/dev-logging/DevLoggingContext";
import { useConfig } from "./AppConfigHook";
// Set the default state values for each context
export const ApplicationConfigContext = /*#__PURE__*/createContext({});
export const ApplicationConfigContextProvider = ({
  children,
  configItems,
  initialConfig
}) => {
  const hook = useConfig(configItems, initialConfig);
  const {
    stateTracker
  } = useDevLogging();
  const configContext = useMemo(() => {
    stateTracker.trackState({
      config: {
        ...hook.config,
        configItems
      },
      floConfig: {
        ...hook.floConfig
      }
    });
    return {
      ...hook
    };
  }, [hook.config, hook.floConfig]);
  return /*#__PURE__*/React.createElement(ApplicationConfigContext.Provider, {
    value: configContext
  }, children);
};
export const useAppConfig = () => {
  return useContext(ApplicationConfigContext);
};
ApplicationConfigContextProvider.propTypes = {
  children: PropTypes.node.isRequired,
  configItems: PropTypes.array.isRequired,
  initialConfig: PropTypes.object
};